import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { ContractStatusEnum } from "@edp-enums/contract-status-enum";
import { IPropertyType } from "@edp-components/edp-contract/edp-contract.model";

@Component({
    selector: "edp-card-contract",
    templateUrl: "./edp-card-contract.component.html",
    styleUrls: ["./edp-card-contract.component.scss"],
})
export class EdpCardContractComponent implements OnInit {
    @Input() contract: Contract;
    @Input() selected: Contract;
    @Output() selectedContract: EventEmitter<Contract> = new EventEmitter<Contract>();

    public type: IPropertyType;
    public fullAddress: string;
    public ContractStatusEnum = ContractStatusEnum;

    ngOnInit() {
        this.type = this.contract.getTypeProperties(this.contract.getType());
        this.fullAddress = this.contract.getInstallationAddress().toString();
    }

    public selectContract = (contract: Contract) => {
        this.selectedContract.emit(contract);
    }
}
